import "core-js/modules/es.array.push.js";
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/ukImages/footer_icon_a.webp';
import _imports_1 from '@/assets/ukImages/footer_icon_b.webp';
const _withScopeId = n => (_pushScopeId("data-v-244e0f2f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "footer"
};
const _hoisted_2 = {
  class: "footer-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer_title"
}, "SEND AN ENQUIRY", -1));
const _hoisted_4 = {
  class: "contact_box"
};
const _hoisted_5 = {
  class: "sel_item"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sel_img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
const _hoisted_7 = {
  class: "sel_item"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sel_img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_9 = {
  class: "sel_btn"
};
const _hoisted_10 = {
  class: "other"
};
const _hoisted_11 = {
  class: "products"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "PRODUCT", -1));
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "links"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "QUICK LINK", -1));
const _hoisted_16 = ["onClick"];
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "compony-info"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "info_name"
}, "CONTACT US"), /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createTextVNode(" Learn more about SANY machinery and capabilities or get help locating your local dealer by contacting SANY UK today. "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("span", null, "+44 1315070088"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("a", {
  class: "products-item",
  href: "mailto:uksales@sanygroup.com"
}, "uksales@sanygroup.com"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("Unit 6, M8 Interlink Estate, Coatbridge, Glasgow, ML5 4RP ")])], -1));
import { ref, reactive, nextTick } from "vue";
import { useHttp, useRequest } from "@/utils/initInstance";
import { useRoute, useRouter } from "vue-router";
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const {
      $api,
      $router
    } = useHttp();
    // 其他产品分类
    const productCategoryList = reactive([{
      categoryName: "CRANES"
    }, {
      categoryName: "TELEHANDLERS"
    }, {
      categoryName: "WHEEL LOADERS"
    }, {
      categoryName: "PILING EQUIPMENT"
    }]);
    // 几个查看页面分类
    const links = reactive([{
      name: "ABOUT US",
      path: "/AboutView"
    }, {
      name: "SERVICE",
      path: "/serviceView"
    }, {
      name: "FINANCE",
      path: "/FinanceView"
    }]);
    // 跳至sany
    function enterSany() {
      window?.gtag_click_all && window.gtag_click_all(1);
      window.open("https://www.sanyuk.com/");
    }
    // 地址跳转
    function handleLink(path, query) {
      window?.gtag_click_all && window.gtag_click_all(1);
      router.push({
        path,
        query
      });
    }
    // 获取留资categary列表
    const categoryValue = ref();
    const modelValue = ref();
    const categaryList = ref([]);
    getcategaryList();
    async function getcategaryList() {
      try {
        const {
          data: res
        } = await $api.getProductSelect();
        for (let item of res.row) {
          item.value = item.categoryName;
          item.label = item.categoryName;
        }
        categaryList.value = res.row || [];
        localStorage.setItem("categaryList", JSON.stringify(res.row));
      } catch (error) {
        console.log(error);
      }
    }
    // 根据cateGarY获取产品集合
    const modelList = ref([]);
    function handleCategoryChange(val) {
      window?.gtag_click_all && window.gtag_click_all(1);
      console.log(val);
      if (val == undefined) {
        modelList.value = [];
        modelValue.value = "";
        return;
      }
      getModelList(val);
    }
    function extractFirstNumber(str) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : 0;
    }
    function sortObjectsArray(arr, key) {
      return arr.sort((a, b) => {
        const startsWithSyA = a[key].startsWith("SY");
        const startsWithSyB = b[key].startsWith("SY");
        if (startsWithSyA && startsWithSyB) {
          const numA = extractFirstNumber(a[key]);
          const numB = extractFirstNumber(b[key]);
          return numA - numB;
        }
      });
    }
    async function getModelList(val) {
      let ids = "";
      for (let item of categaryList.value) {
        if (item.categoryName == val) {
          ids = item.id;
        }
      }
      let obj = {
        productCategory: ids
      };
      try {
        const {
          data: res
        } = await $api.getProductList(obj);
        for (let item of res.row) {
          item.value = item.productName;
          item.label = item.productName;
        }
        let sortedArray = res.row.filter(item => !item.label.startsWith("SY")).concat(res.row.filter(item => item.label.startsWith("SY")));
        modelList.value = sortObjectsArray(sortedArray, "label") || [];
      } catch (error) {
        console.log(error);
      }
    }
    // 前往留资页面
    function enterContact() {
      window.gtag_click_all(1);
      router.push({
        path: "/inquiry",
        query: {
          productCategory: categoryValue.value,
          productModel: modelValue.value
        }
      });
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      return _unref(router).currentRoute.value.name != 'newInquiry' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_select, {
        modelValue: categoryValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => categoryValue.value = $event),
        class: "m-2",
        placeholder: "Product Category",
        size: "large",
        onChange: handleCategoryChange,
        onClear: _ctx.handleClear,
        "no-data-text": "NO Data",
        clearable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categaryList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "onClear"])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_select, {
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => modelValue.value = $event),
        class: "m-2",
        placeholder: "Product Model",
        "no-data-text": "NO Data",
        size: "large",
        clearable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
        onClick: enterContact
      }, {
        default: _withCtx(() => [_createTextVNode("CONTACT US")]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", {
        class: "products-item",
        onClick: _cache[2] || (_cache[2] = $event => handleLink('/productView', {
          category: 1,
          isRoll: 1
        }))
      }, " EXCAVATORS "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productCategoryList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "products-item",
          onClick: $event => handleLink('/otherProducts', {
            category: 2,
            isRoll: 1,
            categoryName: item.categoryName
          })
        }, _toDisplayString(item.categoryName), 9, _hoisted_13);
      }), 128))]), _createElementVNode("div", _hoisted_14, [_hoisted_15, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i
        }, [_createElementVNode("div", {
          class: "products-item",
          onClick: $event => handleLink(item.path, {})
        }, _toDisplayString(item.name), 9, _hoisted_16)]);
      }), 128)), _createElementVNode("div", {
        class: "products-item",
        onClick: enterSany
      }, "SANY UK")]), _hoisted_17])])])) : _createCommentVNode("", true);
    };
  }
};